import { ChangeDetectionStrategy, Component, EventEmitter, Output } from '@angular/core';
import { TranslocoDirective } from '@jsverse/transloco';
import { CardButtonComponent } from '@modules/shared/card-button/card-button.component';
import { ChoicePickerComponent } from '@modules/shared/choice-picker/choice-picker.component';
import { CreatorType } from '@pixacare/domain';

@Component({
  selector: 'pxc-telemonitoring-request-type',
  imports: [TranslocoDirective, CardButtonComponent, ChoicePickerComponent],
  templateUrl: './telemonitoring-request-type.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TelemonitoringRequestTypeComponent {
  @Output() creatorTypeChange: EventEmitter<CreatorType> = new EventEmitter<CreatorType>();

  byPatient(): void {
    this.creatorTypeChange.emit(CreatorType.BY_PATIENT);
  }

  byUser(): void {
    this.creatorTypeChange.emit(CreatorType.BY_USER);
  }
}
